document.addEventListener("click", e => {
  const modal = document.getElementById("myPopupModal");
  if (!modal) return;

  if (e.target.closest(".myPopupBtn")) {
    e.preventDefault();
    modal.style.display = "block";
  }

  if (e.target.classList.contains("myPopupClose") || e.target === modal) {
    e.preventDefault();
    modal.style.display = "none";
  }
});
